import useAuthService from 'api/services/authService'
import useFavoritesService from 'api/services/favoritesService'
import { getAuthUserSubject } from 'api/utils/AuthManager'
import Loading from 'components/common/loading/Loading'
import Modal from 'components/common/modal/Modal'
import PropertyList from 'components/listings/Listings'
import useListingFavorite from 'components/propertyCard/useListingFavorite'
import { useQuery, useQueryClient } from 'react-query'
import { useNavigate, useLocation } from 'react-router-dom'
import { ListedProperty } from 'types/property'

import { i18n } from '../../i18n'

const FavoritesPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const queryClient = useQueryClient()
  const { loadFavorites } = useFavoritesService()
  const { user: authUser } = useAuthService()
  const currentUserId = getAuthUserSubject(authUser)

  const returnTo =
    (location.state as { returnTo?: string } | null)?.returnTo ?? '/'

  const handleClose = () => navigate(returnTo)

  const favoritesQueryKey = ['loadFavorites', currentUserId]

  const { data: favorites = [], isLoading } = useQuery<ListedProperty[]>(
    favoritesQueryKey,
    loadFavorites,
    { enabled: Boolean(currentUserId) }
  )

  const { handleFavorite, loadingFavoriteId } = useListingFavorite({
    properties: favorites,
    onToggleFavorite: (propertyId: string, isFavorited: boolean) => {
      if (isFavorited) return

      queryClient.setQueryData<ListedProperty[]>(favoritesQueryKey, (oldFavorites = []) =>
        oldFavorites.filter(property => String(property.id) !== String(propertyId))
      )
    },
  })

  if (isLoading) return <Loading />

  return (
    <Modal
      icon="regular-star"
      isOpen
      onClose={handleClose}
      title={i18n.translate('common.favorites')}
      isLoading={isLoading}
    >
      <PropertyList
        properties={favorites}
        handleFavorite={handleFavorite}
        loadingFavoriteId={loadingFavoriteId}
        returnTo="/favorites"
      />
    </Modal>
  )
}

export default FavoritesPage
